import { Link } from 'react-router-dom'
import { ChevronRight, Home } from 'lucide-react'
import { cn } from '@/utils/cn'

interface BreadcrumbItem {
  label: string
  href?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  className?: string
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <nav aria-label="breadcrumb" className={cn("flex items-center gap-1 text-sm mb-6", className)}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1
        return (
          <span key={index} className="flex items-center gap-1">
            {index > 0 && (
              <ChevronRight size={14} className="text-brand-text-muted flex-shrink-0" />
            )}
            {isLast ? (
              <span className="text-brand-text font-medium truncate max-w-[200px]" title={item.label}>
                {item.label}
              </span>
            ) : (
              <Link
                to={item.href ?? '#'}
                className="text-brand-text-muted hover:text-brand-primary transition-colors flex items-center gap-1"
              >
                {index === 0 && <Home size={13} />}
                {item.label}
              </Link>
            )}
          </span>
        )
      })}
    </nav>
  )
}
